import { IControlProvider } from '@ibiz-template/runtime';

/**
 * 多数据部件适配器
 *
 * @author chitanda
 * @date 2023-06-16 10:06:51
 * @export
 * @class MDCTRLProvider
 * @implements {IControlProvider}
 */
export class MDCtrlProvider implements IControlProvider {
  component: string = 'IBizMDCtrlControl';
}
